import React from 'react';
import { Modal, fmtDate } from '../finance/shared';
import Icon from '../../../components/dashboard/DashboardIcons';

const STATUS_LABELS = { pending_activation: 'بانتظار التفعيل', active: 'نشطة', suspended: 'معلقة', ended: 'منتهية' };
const STATUS_COLORS = { pending_activation: 'bg-amber-50 text-amber-700', active: 'bg-teal-50 text-teal-700', suspended: 'bg-orange-50 text-orange-700', ended: 'bg-slate-100 text-slate-500' };

/** عرض تفاصيل عقد المدرب بعد الموافقة والتعاقد — بيانات الوظيفة، الفرق المسندة، الراتب والملاحظات */
export default function CoachContractModal({ membership, teams, categories, employees, onClose }) {
  if (!membership) return null;
  const teamNames = (membership.team_ids || []).map((id) => teams.find((t) => t.id === id)?.name).filter(Boolean);
  const categoryNames = (membership.category_ids || []).map((id) => categories.find((c) => c.id === id)?.name).filter(Boolean);
  const employee = employees.find((e) => e.id === membership.employee_id);

  return (
    <Modal open={Boolean(membership)} title="عقد المدرب" onClose={onClose} wide>
      <div className="space-y-4" data-testid="coach-contract-modal">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-bold text-slate-800">{membership.title} — {membership.coach_name}</h3>
            <div className="text-xs text-slate-500">{membership.season && `موسم ${membership.season}`}</div>
          </div>
          <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_COLORS[membership.status]}`}>{STATUS_LABELS[membership.status]}</span>
        </div>

        <div className="grid grid-cols-2 gap-3 text-sm sm:grid-cols-3">
          <div><span className="block text-[11px] text-slate-400">تاريخ البدء</span><span className="font-semibold text-slate-700">{fmtDate(membership.start_date)}</span></div>
          {membership.end_date && <div><span className="block text-[11px] text-slate-400">تاريخ الانتهاء</span><span className="font-semibold text-slate-700">{fmtDate(membership.end_date)}</span></div>}
          {membership.activated_at && <div><span className="block text-[11px] text-slate-400">تاريخ التفعيل</span><span className="font-semibold text-slate-700">{fmtDate(membership.activated_at)}</span></div>}
          {membership.salary_amount != null && <div><span className="block text-[11px] text-slate-400">الراتب</span><span className="font-semibold text-slate-700">{membership.salary_amount} {membership.salary_currency || 'SAR'}</span></div>}
          {employee && <div><span className="block text-[11px] text-slate-400">مرتبط بموظف</span><span className="font-semibold text-slate-700">{employee.full_name || employee.name}</span></div>}
        </div>

        {teamNames.length > 0 && (
          <div>
            <h4 className="mb-1.5 text-xs font-bold text-slate-500">الفرق المسندة</h4>
            <div className="flex flex-wrap gap-1.5" data-testid="coach-contract-teams">
              {teamNames.map((n, i) => <span key={i} className="flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs text-slate-600"><Icon name="userGroup" className="h-3 w-3" />{n}</span>)}
            </div>
          </div>
        )}
        {categoryNames.length > 0 && (
          <div>
            <h4 className="mb-1.5 text-xs font-bold text-slate-500">الفئات المسندة</h4>
            <div className="flex flex-wrap gap-1.5" data-testid="coach-contract-categories">
              {categoryNames.map((n, i) => <span key={i} className="flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs text-slate-600"><Icon name="tag" className="h-3 w-3" />{n}</span>)}
            </div>
          </div>
        )}

        {membership.contract_note && (
          <div>
            <h4 className="mb-1 text-xs font-bold text-slate-500">ملاحظات العقد</h4>
            <p className="whitespace-pre-line rounded-lg bg-slate-50 p-3 text-sm text-slate-700" data-testid="coach-contract-note">{membership.contract_note}</p>
          </div>
        )}

        <div className="flex justify-end border-t border-slate-100 pt-3">
          <button onClick={onClose} className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-600" data-testid="coach-contract-close-btn">إغلاق</button>
        </div>
      </div>
    </Modal>
  );
}
